import { useEffect, useState } from "react";
import { api } from "../api/client";

interface OrderRow {
  id: string;
  provider: string;
  symbol: string;
  side: string;
  type: string;
  quantity: number;
  price: number | null;
  status: string;
  created_at: number;
}

export function Orders() {
  const [rows, setRows] = useState<OrderRow[]>([]);
  async function load() {
    try {
      const data = await api<OrderRow[]>("/v1/orders");
      setRows(data);
    } catch {
      setRows([]);
    }
  }
  useEffect(() => {
    load();
  }, []);

  async function cancel(id: string) {
    await api(`/v1/orders/${id}/cancel`, { method: "POST" });
    load();
  }

  return (
    <div className="page">
      <h1>Orders</h1>
      <table className="markets-table">
        <thead>
          <tr>
            <th>When</th>
            <th>Symbol</th>
            <th>Side</th>
            <th>Type</th>
            <th className="num">Qty</th>
            <th className="num">Price</th>
            <th>Status</th>
            <th>Provider</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {rows.map((o) => (
            <tr key={o.id}>
              <td className="muted">{new Date(o.created_at * 1000).toLocaleString()}</td>
              <td>{o.symbol}</td>
              <td className={o.side === "buy" ? "up" : "down"}>{o.side}</td>
              <td>{o.type}</td>
              <td className="num">{o.quantity}</td>
              <td className="num">{o.price ?? "—"}</td>
              <td>{o.status}</td>
              <td className="muted">{o.provider}</td>
              <td>
                {(o.status === "accepted" || o.status === "open") && (
                  <button type="button" className="btn btn-ghost btn-sm" onClick={() => cancel(o.id)}>
                    Cancel
                  </button>
                )}
              </td>
            </tr>
          ))}
          {rows.length === 0 && (
            <tr>
              <td colSpan={9} className="muted">
                No orders yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
